export default __webpack_public_path__ + "static/media/visual2.8c99d802.png";